import { SharePanelAction, SharePanelActionKeys } from './actions';
import { Api } from '../../typings/api';
import Utils from '../../utils';

enum FormType {
	Uprez = 'uprezForm',
	Webpublication = 'webpublicationForm'
}

interface FormState {
	company: string;
	contactEmail: string;
	userName: string;
	firstname: string;
	message: string;
	userEmail: string;
	subject: string;
	phone: string;
	position: string;
	surname: string;
	createDeal: boolean;
}

interface SharePanelState {
	isOpen: boolean;
	isProcessing: boolean;
	selection: Api.DriveItem[];
	foldersContent: Api.DriveItem[];
	form: FormState;
	isProposalShare: boolean;
	crmContacts: Api.CrmContact[];
}

const initialFormState = {
	company: '',
	firstname: '',
	subject: '',
	phone: '',
	position: '',
	surname: '',
	contactEmail: '',
	message: '',
	userEmail: '',
	userName: '',
	createDeal: false,
};

const initialState: SharePanelState = {
	isOpen: false,
	isProcessing: false,
	selection: [],
	foldersContent: [],
	form: initialFormState,
	isProposalShare: false,
	crmContacts: [],
};

function sharePanel(
	state: SharePanelState = initialState,
	action: SharePanelAction
): SharePanelState {
	let newState = Utils.deepCopy(state);
	switch (action.type) {
		case SharePanelActionKeys.OPEN_PANEL:
			newState.isOpen = true;
			newState.isProposalShare = action.isProposalShare;
			return newState;
		case SharePanelActionKeys.CLOSE_PANEL:
			newState.isOpen = false;
			newState.isProposalShare = false;
			newState.foldersContent = [];
			return newState;
		case SharePanelActionKeys.START_PROCESSING:
			newState.isProcessing = true;
			return newState;
		case SharePanelActionKeys.FINISH_PROCESSING:
			newState.isProcessing = false;
			return newState;
		case SharePanelActionKeys.RESET_FORM:
			newState.form = initialFormState;
			newState.selection = [];
			return newState;
			case SharePanelActionKeys.SET_SELECTION:
			newState.selection = action.selection;
			return newState;
		case SharePanelActionKeys.SET_FORM_FIELD:
			newState.form[action.name] = action.value;
			return newState;
		case SharePanelActionKeys.UPDATE_FOLDERS_CONTENT:
			newState.foldersContent = [...state.foldersContent, action.item];
			return newState;
		case SharePanelActionKeys.SET_CRM_CONTACTS:
			newState.crmContacts = action.crmContacts;
			return newState;
		default:
			return state;
	}
}

export { SharePanelState, FormState, FormType, sharePanel };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/reducer.ts